import { Icon } from "@chakra-ui/react"
import React from "react"

export const PlaneIcon = props => (
  <Icon
    fill="currentColor"
    stroke="currentColor"
    viewBox="0 0 25 26"
    {...props}
  >
    <path d="M1 13v4.785c0 .697.697 1.296 1.493 1.296.598 0 1.195-.4 1.394-.897l1.095-2.791h3.784v7.575c0 .499.199.997.597 1.396.299.299.698.498 1.095.598.996.199 1.893-.4 2.191-1.296l2.788-8.273h6.273c1.195 0 2.29-.998 2.29-2.294 0-1.196-.996-2.293-2.29-2.293h-6.273l-2.788-8.273c-.298-1.097-1.195-1.695-2.191-1.495a2.372 2.372 0 00-1.095.597c-.398.5-.597.997-.597 1.496v7.576H4.982l-1.095-2.89c-.199-.5-.796-.899-1.394-.899-.796 0-1.493.6-1.493 1.296V13z" />
  </Icon>
)
